import React, { useState } from "react";
import BackButton from "../../components/BackButton";
import SlideShow from "../../components/SlideShow";
import { Helmet } from "react-helmet-async";
import abstractCollection from "../../data/Paintings/abstracts_Data.js";
// import imageScroller from "../../utils/imageScroller";
import NavSpacer from "./../../components/NavSpacer";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Link } from "react-router-dom";

function Abstracts() {
  const [isHovered, setIsHovered] = useState(false);
  // useEffect(() => {
  //   imageScroller("App");
  // });
  return (
    <div>
      <Helmet>
        <title>Abstracts — Paintings by Tyrone Layne</title>
        <meta property='og:image' content={abstractCollection[0].image} />
        <link rel='canonical' href='https://tyronelayne.com/paintings/abstracts' />
      </Helmet>
      <NavSpacer />
      <Breadcrumbs />
      <SlideShow
        slides={abstractCollection}
        slideShowName='abstracts'
        startingIndex={0}
        scrollOffset={-40}
      />
      <div style={{ textAlign: "center", margin: "4rem 0 2rem 0" }}>
        <Link
          to="/painting-shop/abstracts"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "inline-block",
            padding: "14px 32px",
            backgroundColor: isHovered ? "#000" : "transparent",
            color: isHovered ? "#fff" : "#000",
            border: "1px solid #000",
            borderRadius: "0",
            fontSize: "0.85rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            textDecoration: "none",
            transition: "background-color 0.2s ease, color 0.2s ease",
            fontFamily: "inherit",
          }}
        >
          Shop available abstract paintings
        </Link>
      </div>
      <BackButton />
    </div>
  );
}

export default Abstracts;
